import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpClientJsonpModule} from "@angular/common/http";

import {GeneralEffects} from "./store/general/general-effects.service";
import {StoreDevtoolsModule} from "@ngrx/store-devtools";
import {environment} from "../environments/environment";
import {TokenInterceptor} from "./services/token-interceptor.service";
import {appReducers} from "./store/app.state";
import {ToastrModule} from "ngx-toastr";
import {AuthEffects} from "./store/auth/auth.effects";
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {it} from 'date-fns/locale';
import {TranslocoRootModule} from "./transloco-root.module";
import {TranslocoService} from "@ngneat/transloco";


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    StoreModule.forRoot(appReducers, {}),
    EffectsModule.forRoot([GeneralEffects, AuthEffects]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    BrowserAnimationsModule,

    HttpClientModule,
    HttpClientJsonpModule,
    ToastrModule.forRoot(),
    TranslocoRootModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },{
      provide: MAT_DATE_LOCALE,
      useValue: it,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(translocoService: TranslocoService) {
  // translocoService.load(translocoService.getDefaultLang());


  }
}



